export default {
  '概况':'Overview',
  '展示当前最新数据':'Displaying latest data',
  '人已参加运动':'participants',
  '完成任意一项运动':'Participation includes any activity: assignments, training, tests, teaching, events',
  '学生人数':'Students',
  '班级数量':'Classes',
  '教职工数量':'Staff',
  '设备数量':'Devices',
  '加载中':'Loading...',
  '自主锻炼':'Voluntary Exercise',
  '数据来源':'Data from campus/off-campus free exercise, recreational activities, and competitions (excludes assignments/events)',
  '自主锻炼情况':'Voluntary Exercise Status',
  '各年级自主锻炼情况':'Grade-level Exercise Participation',
  '各年级锻炼时长':'Exercise Duration by Grade',
  '各项目锻炼时长':'Exercise Duration by Activity',
  '各年级每日锻炼时长对比':'Daily Exercise Duration Comparison by Grade',
  '各年级锻炼参与趋势':'Exercise Participation Trend by Grade',
  '国家学生体质健康测试':'National Student Fitness Test',
  '数据来源为国家学生体质健康测试板块':'Data from National Student Fitness Test module',
  '测试人数':'Test Participants',
  '成绩分布':'Score Distribution',
  '各年级成绩分布':'Score Distribution by Grade',
  '总分(下拉筛选项目)':'Total Score (filter by item)',
  '男生':'Male',
  '女生':'Female',
  '参与率':'Participation Rate',
  '总人数':'Total',
  '参与人数':'Participants',
  '参与率（%）':'Participation Rate (%)',
  '人数':'Count',
  '时长(分钟)':'Duration (mins)',
  '运动时长':'Exercise Duration',
  '分钟':'minutes',
  '占比':'Proportion',
  '总计':'Total',
  '人':'people',
  '参与测试':'Tested',
  '未参与测试':'Not Tested',
  '优秀':'Excellent',
  '良好':'Good',
  '及格':'Pass',
  '不及格':'Fail',
  '正常':'Normal',
  '低体重':'Underweight',
  '超重':'Overweight',
  '肥胖':'Obese',
  '(本学年)':'(Academic Year)',
  '(本学期)':'(Semester)',
  '查看班级数据':'View Class Data',
  '各班级参与运动情况':'Class Participation Status',
  '各班级运动时长':'Exercise Duration by Class',
  '各项目运动时长':'Exercise Duration by Activity',
  '各班级每日锻炼时长对比':'Daily Exercise Duration Comparison by Class',
  '各班级锻炼参与趋势':'Exercise Participation Trend by Class',
  '人均':'Per Capita',
  '总数':'Total',
  '各班级成绩分布':'Score Distribution by Class',
  '参与运动情况':'Participation Status',
  '年级':'Grade',
  '班级列表':'Class List',
  '班级详情':'Class Details',
  '课堂看板':'Class Dashboard',
  '个人数据':'Personal Data',
  '今日活跃':'Active Today',
  '本周活跃':'Active This Week',
  '查看学生数据':'View Student Data',
  '自主锻炼人数':'Voluntary Exercise Participants',
  '每日运动人数':'Daily Participants',
  '每日运动时长':'Daily Exercise Duration',
  '运动时长TOP5':'Top 5 Exercise Durations',
  '测试概况':'Test Overview',
  '各项目平均分':'Average Scores by Activity',
  '年级平均':'Grade Average',
  '成绩及格率':'Pass Rate',
  '总时长':'Total Duration',
  '人均时长':'Duration Per Capita',
  '学生列表':'Student List',
  '关键字搜索':'Keyword Search',
  '个人画像':'Personal Profile',
  '今日运动':'Today\'s Exercise',
  '班级排名':'Class Ranking',
  '本周运动':'Weekly Exercise',
  '日均时长':'Daily Average',
  '运动处方':'Exercise Prescription',
  '体质测试结果':'Fitness Test Results',
  '身体素质评估':'Physical Fitness Assessment',
  '身体机能':'Physical Function',
  '身体素质':'Physical Fitness',
  '身体形态':'Body Composition',
  '班级平均':'Class Average',
  '个人运动时长':'Personal Exercise Duration',
  '我':'Me',
  '我的平均分':'My Average',
  '班级平均分':'Class Average',
  '时长（分钟）':'Duration (minutes)',
}